import { render, staticRenderFns } from "./ListReport.vue?vue&type=template&id=3b7f72b6"
import script from "./ListReport.vue?vue&type=script&lang=js"
export * from "./ListReport.vue?vue&type=script&lang=js"
import style0 from "./ListReport.vue?vue&type=style&index=0&id=3b7f72b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports